import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringFilterBrands'
})
export class StringFilterPipeBrands implements PipeTransform {

  transform(categories: any, searchText: any): any {
    if(categories == null){
      return null;
    }
    if (searchText == null) return categories;

    return categories.filter(function (category) {
      return category.brand_name.toLowerCase().indexOf(searchText) > -1 || category.serviceprovidertype.toLowerCase().indexOf(searchText) > -1;
    })
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/-pipe/string-filter/string-filter-brands.pipe.ts